import { DotsHorizontalIcon } from "@heroicons/react/outline";
import { MouseEventHandler } from "react";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";

import "./actionsMenu.css";

type ActionsMenuProps = {
  id: string;
  actions: {
    label: string;
    type?: ActionsMenuType;
    url?: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    tooltip?: string;
    disabled?: boolean;
  }[];
};

export enum ActionsMenuType {
  BUTTON = "button",
  LINK = "link",
  OUTSIDE_LINK = "outsideLink",
}

const ActionsMenu = ({ id, actions }: ActionsMenuProps) => {
  return (
    <>
      <div data-for={id} data-tip="" className="Tooltip__ellipsis">
        <DotsHorizontalIcon />
      </div>
      <ReactTooltip
        id={id}
        place="top"
        effect="solid"
        clickable
        event="click"
        backgroundColor="transparent"
        borderColor="transparent"
        textColor="black"
        padding="0"
      >
        <div className="Tooltip">
          {actions.map((action, index) => {
            switch (action.type) {
              case ActionsMenuType.LINK:
                return (
                  <Link
                    to={action.url || ""}
                    key={index}
                    className="Tooltip__button"
                    data-tip={action.tooltip}
                  >
                    {action.label}
                  </Link>
                );
              case ActionsMenuType.OUTSIDE_LINK:
                return (
                  <a
                    className="Tooltip__button"
                    key={index}
                    href={action.url || ""}
                    target="_blank"
                    rel="noreferrer"
                    data-tip={action.tooltip}
                  >
                    {action.label}
                  </a>
                );
              default:
                return (
                  <button
                    className="Tooltip__button"
                    onClick={action.onClick}
                    disabled={action.disabled}
                    key={index}
                    data-tip={action.tooltip}
                  >
                    {action.label}
                  </button>
                );
            }
          })}
        </div>
      </ReactTooltip>
    </>
  );
};

export default ActionsMenu;
